import * as Accordion from '@radix-ui/react-accordion';
import Image from 'next/image';
import { Button, Icon } from '@pairy/pds-react';

import { logo } from '@/components/User/_components/pdf/BulkLogos/index.constants';
import { TriggerChevronIcon } from '@/styles/Accordion/ViewHistoryAccordion.styles';

import * as Styled from '../../index.styles';
import useCopy from '../../useCopy';

const ActiveCampaign = () => {
  const copy = useCopy();

  return (
    <>
      <Accordion.Header>
        <Styled.AccordionTrigger>
          <Image
            src={logo.activeCampaign.src}
            alt={logo.activeCampaign.alt}
            width={logo.activeCampaign.width}
            height={logo.activeCampaign.height}
          />
          <TriggerChevronIcon icon="ph:caret-up" size={19} />
        </Styled.AccordionTrigger>
      </Accordion.Header>
      <Styled.AccordionContent>
        <Button
          type="button"
          width="100%"
          variant="skyblue_300"
          textVariant="md-medium"
          radius={8}
          paddingX={16}
          paddingY={12}
          InnerWrappeGap={4}
          marginTop={16}
          leftIcon={<Icon icon="ph:link" size={17} />}
          onClick={() => copy('activeCampaign')}
        >
          ActiveCampaign용 링크 생성하기
        </Button>
      </Styled.AccordionContent>
    </>
  );
};

export default ActiveCampaign;
